module.exports = __webpack_public_path__ + "img/newsImg11-27.36df0f7a.png";